import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link } from "react-router-dom";
import { FaFolderOpen, FaPlus, FaSave, FaTrash, FaFolder } from "react-icons/fa";
import "assets/theme/admin_list.css";

const GalleryCategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await apiFetch("leader_admin/get_gallery_categories");
      setCategories(res.data || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle Inline Name Change
  const handleNameChange = (id, value) => {
    setCategories((prev) =>
      prev.map((item) => (item.id === id ? { ...item, name: value } : item))
    );
  };

  // Direct Update API Call
  const handleUpdate = async (id, name) => {
    if (!name || !name.trim()) {
      alert("कृपया श्रेणीचे नाव प्रविष्ट करा");
      return;
    }

    try {
      await apiFetch(`leader_admin/update_gallery_categories/${id}`, {
        method: "PUT",
        body: JSON.stringify({ name }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      alert("श्रेणी यशस्वीरीत्या अद्यतनित झाली");
      fetchCategories();
    } catch (error) {
      alert(error.message);
    }
  };

  // Delete Category API Call
  const handleDelete = async (id) => {
    if (!window.confirm("तुम्हाला ही गॅलरी श्रेणी हटवायची आहे याची खात्री आहे का?")) return;

    try {
      await apiFetch(`leader_admin/delete_gallery_categories/${id}`, {
        method: "DELETE",
      });
      alert("श्रेणी यशस्वीरीत्या हटवली गेली");
      fetchCategories();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaFolderOpen />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  गॅलरी विभाग व्यवस्थापन / Gallery Category Management
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  गॅलरी श्रेणी जोडा, संपादित करा व व्यवस्थापित करा (Full CRUD)
                </p>
              </div>
            </div>

            <Link to="/add_gallery_category" className="btn btn-admin-add">
              <FaPlus /> <span>नवीन श्रेणी जोडा (Add Category)</span>
            </Link>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status" />
                <p className="text-muted mt-2 fw-semibold mb-0">श्रेणी लोड होत आहेत...</p>
              </div>
            ) : categories.length === 0 ? (
              <div className="text-center py-5">
                <FaFolder className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">कोणतीही गॅलरी श्रेणी आढळली नाही</h6>
                <p className="text-muted small mb-0">No gallery categories available yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>विभागाचे नाव (Category Name)</th>
                      <th className="text-end" style={{ width: "160px" }}>कृती (Actions)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {categories.map((item, index) => (
                      <tr key={item.id}>
                        <td className="fw-bold text-secondary">
                          {(index + 1).toString().padStart(2, "0")}
                        </td>

                        {/* Editable Name */}
                        <td>
                          <input
                            type="text"
                            className="form-control form-control-sm border-secondary-subtle rounded-3"
                            style={{ maxWidth: "400px" }}
                            value={item.name}
                            onChange={(e) => handleNameChange(item.id, e.target.value)}
                          />
                        </td>

                        {/* Action Buttons */}
                        <td className="text-end">
                          <div className="d-flex justify-content-end gap-2">
                            <button
                              className="btn btn-sm btn-success px-3 rounded-3 d-flex align-items-center gap-1"
                              onClick={() => handleUpdate(item.id, item.name)}
                              title="अद्यतनित करा"
                            >
                              <FaSave /> जतन
                            </button>

                            <button
                              className="btn-action-icon delete"
                              onClick={() => handleDelete(item.id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default GalleryCategoryList;